import { type FC } from 'react';

import { useGetLotterySeasonHistoryWinnersQuery } from '@/api/queries/lottery/lottery';
import { type LotteryTicketType } from '@/common/types/lottery';

import { WinnerItem } from '../WinnerItem/WinnerItem';

interface SeasonWinnersHistoryProps {
  seasonId: string;
  type: LotteryTicketType;
}

const SeasonWinnersHistory: FC<SeasonWinnersHistoryProps> = ({
  type,
  seasonId,
}) => {
  const { data } = useGetLotterySeasonHistoryWinnersQuery({
    type,
    id: seasonId,
  });

  return (
    <div className="w-full flex flex-col flex-1 gap-[2px] overflow-y-auto hidden-scrollbar">
      {data?.map((winnerInfo) => (
        <WinnerItem key={winnerInfo.id} {...winnerInfo} />
      ))}
    </div>
  );
};

export { SeasonWinnersHistory };
